import $ from "jquery";
import React, { useRef, useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import { useHistory, useParams } from 'react-router';
import { LoadingSpinner } from '../../components/Loader/Loader';
import http from '../../config/BaseUrl';
import FormBuilderData from '../../dbJson/FormBuilderData.json'
import { AiOutlineForm } from 'react-icons/ai'
import { ToastContainer, toast } from "react-toastify";

window.jQuery = $;
window.$ = $;
require("jquery-ui-sortable");
require("formBuilder");
// require("formBuilder/dist/form-render.min.js");

export function EventFormBuilderEdit() {
  const fb = useRef(null);;
  const { id } = useParams()
  const [form, setForm] = useState(null);
  const history = useHistory();
  const formData = history.location.state.formData
  const [loading, setLoading] = useState(false)

  const [selectFormBuilder, setSelectFormBuilder] = useState(false)

  const { customerFeedBack, eventFeedBack, pollFeedBack, memberFeedBack } = FormBuilderData


  useEffect(() => {
    if (formData) {
      setSelectFormBuilder(formData)
      setFormBuilder(formData.form_name, formData.form_data)
    }
  }, [formData])



  const handleSubmit = () => {
    if (Object.keys(selectFormBuilder).length > 0 && selectFormBuilder.form_data.length > 0) {

      let offer = {
        eventId: id,
        form_name: selectFormBuilder.form_name,
        form_data: selectFormBuilder.form_data
      }

      try {
        setLoading(true)
        http.put(`form-data-update/${id}`, offer).then((res) => {
          setLoading(true)
          if (res.data) {
            history.push(`/show/event/${id}`, 'Information Updated.')
          }
        }).catch((err) => {
          setLoading(false)
        })
      } catch (error) {
        setLoading(false)
      }

    }
    else {
      toast.warning("Please save data before you submitted the form.")
    }
  }

  const areEquals = (a, b) => {
    var keys1 = Object.keys(a)
    var keys2 = Object.keys(b)
    let findNameIndex = keys1.findIndex(x => x === 'name')
    let findName1Index = keys2.findIndex(x => x === 'name')
    
    if (a[keys1[findNameIndex]] === b[keys2[findName1Index]]) {
      return true
    }else{
      return false
    }
  }
  const checkArray = (arr) => {
    for (var i = 1; i < arr.length; i++) {
      if (areEquals(arr[0], arr[i])) return true
    }
    return false
  }

  const setFormBuilder = (defaultName, defaultData) => {
    setSelectFormBuilder({ form_name: defaultName, form_data: defaultData })
    let options2 = {
      disabledAttrs: ['className', 'inline', 'access', 'max', 'min', 'maxlength', 'subtype', 'step', 'help-text', 'multiple', 'other', 'style', 'rows', 'value', 'description'],
      disableFields: ["button", "header", "paragraph", "hidden", "file", "autocomplete", "date"],
      disabledActionButtons: ['data', 'save', 'view'],
      onClearAll: function (formData) {
        setForm(null);
      },

      formData: defaultData || [],
      actionButtons: [
        {
          id: "submit",
          className: "btn btn-primary",
          label: "Save Data",
          type: "button",
          events: {
            click: function () {
              $(() => {
                let myxml = formBuilder.actions.getData("json", true);
                let formInputData = JSON.parse(myxml)
                const checkSameNameInForm = checkArray(formInputData)
                if (checkSameNameInForm) {
                  toast.warning("Same name is not allowed in multiple fields.")
                }else{
                  toast.success("Form have saved.")
                  setSelectFormBuilder({ form_name: defaultName, form_data: JSON.parse(myxml) })
                }
              });
            }
          }
        }
      ],
      controlConfig: {
        'file.fineuploader': {
          autoUpload: true
          // other fine uploader configuration options here
        }
      }
    };
    if (fb.current.children.length > 0) {
      fb.current.removeChild(fb.current.children[0])
    }
    const formBuilder = $(fb.current).formBuilder(options2);
  }


  const chooseFormBuilder = (defaultName, defaultData) => {
    setFormBuilder(defaultName, defaultData)
  }



  return (
    <Layout>
      <div className="p-4 App">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="choose-form-builder">
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Customer Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Customer Feedback', customerFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Customer Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Event Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Event Feedback', eventFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Event Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Poll Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Poll Feedback', pollFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Poll Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Member Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Member Feedback', memberFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Member Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Custom Form' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Custom Form', null)}>
                  <span><AiOutlineForm /></span>
                  <p>Custom Form</p>
                </div>
              </div>
              <div className="custom-form-builder">
                <div id="fb-editor" ref={fb}>
                  <div className="select-any-form mb-5">
                    <p>Select any form</p>
                  </div>
                </div>
              </div>

            </div>

            <div className="col-md-12 text-right">
              {loading ?
                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                  <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                </button>)
                : <button type="button" onClick={handleSubmit} className="float-right px-5 btn btn-primary radius-10">Update</button>
              }

            </div>
          </div>


        </div>


      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </Layout>
  );
}

export default EventFormBuilderEdit;
